/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/


import { createApp } from 'vue'







import '@quasar/extras/fontawesome-v6/fontawesome-v6.css'

import '@quasar/extras/roboto-font/roboto-font.css'

import '@quasar/extras/material-icons/material-icons.css'

import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'




// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'




import 'src/css/app.scss'

import 'feo-app-core/dist/assets/css/bundle.css'

import 'quasar-ui-admin-base/dist/index.css'

import 'quasar-ui-admin-web-pages/dist/index.css'

import 'quasar-ui-admin-web-users/dist/index.css'

import 'quasar-ui-admin-web-newsletter-export/dist/index.css'

import 'quasar-ui-admin-base-attributes/dist/index.css'

import 'quasar-ui-admin-settings/dist/index.css'

import 'quasar-ui-admin-shop/dist/index.css'

import 'quasar-ui-admin-web-gdpr/dist/index.css'

import 'quasar-ui-admin-base-widgets/dist/index.css'

import 'quasar-ui-admin-web-menu-widget/dist/index.css'

import 'quasar-ui-admin-base-attributes-colors/dist/index.css'

import 'quasar-ui-admin-shop-products-widget/dist/index.css'

import 'quasar-ui-admin-web-banner-widget/dist/index.css'


import createQuasarApp from './app.js'
import quasarUserOptions from './quasar-user-options.js'







const publicPath = `/`

async function start ({
  app,
  router
  
}, bootFiles) {
  

  
  let hasRedirected = false
  const getRedirectUrl = url => {
    try { return router.resolve(url).href }
    catch (err) {}

    return Object(url) === url
      ? null
      : url
  }
  const redirect = url => {
    hasRedirected = true

    if (typeof url === 'string' && /^https?:\/\//.test(url)) {
      window.location.href = url
      return
    }

    const href = getRedirectUrl(url)

    // continue if we didn't fail to resolve the url
    if (href !== null) {
      window.location.href = href
      
    }
  }

  const urlPath = window.location.href.replace(window.location.origin, '')

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    try {
      await bootFiles[i]({
        app,
        router,
        
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        redirect(err.url)
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  app.use(router)
  

  

    

    
      app.mount('#q-app')
    

    

  

}

createQuasarApp(createApp, quasarUserOptions)

  .then(app => {
    // eventually remove this when Cordova/Capacitor/Electron support becomes old
    const [ method, mapFn ] = Promise.allSettled !== void 0
      ? [
        'allSettled',
        bootFiles => bootFiles.map(result => {
          if (result.status === 'rejected') {
            console.error('[Quasar] boot error:', result.reason)
            return
          }
          return result.value.default
        })
      ]
      : [
        'all',
        bootFiles => bootFiles.map(entry => entry.default)
      ]

    return Promise[ method ]([
      
      import('boot/core'),
      
      import('boot/plugin'),
      
      import('quasar-app-extension-admin-base/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-web-pages/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-web-users/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-web-newsletter-export/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-base-attributes/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-settings/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-shop/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-web-gdpr/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-base-widgets/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-web-menu-widget/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-base-attributes-colors/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-shop-products-widget/src/boot/register.cjs'),
      
      import('quasar-app-extension-admin-web-banner-widget/src/boot/register.cjs')
      
    ]).then(bootFiles => {
      const boot = mapFn(bootFiles).filter(entry => typeof entry === 'function')
      start(app, boot)
    })
  })

